import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import hydrationLevelWebm from '@/assets/landing-videos/water-fast-m.webm'

const schema: LandingScreenSchema = {
	order: [
		'LandingHead',
		'LandingTitle',
		'LandingSubtitle',
		'LandingVideoAnimation',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'HOW TO LOSE WEIGHT',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			title: 'ACCORDING TO <b>HYDRATION LEVEL</b>',
			uppercase: true,
		}),

		LandingVideoAnimation: (): LandingComponentsConfig['LandingVideoAnimation'] => ({
			url: hydrationLevelWebm,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
